import { luminance } from '@mantine/core';

export function isColorsContrastAccessible(color1: string, color2: string) {
  const luminance1 = luminance(color1);
  const luminance2 = luminance(color2);

  const light = Math.max(luminance1, luminance2);
  const dark = Math.min(luminance1, luminance2);

  const contrastRatio = (light + 0.05) / (dark + 0.05);

  return contrastRatio >= 4.5;
}
